export default "__VITE_ASSET__BO4mcp4j__"